import { Component, OnInit, ViewEncapsulation, ViewChild, Input, ElementRef, OnDestroy } from '@angular/core';

import { HardwareCheckerService } from '../../services/index';
import { Api, Session } from '../../services/index';
import { MediaPermisionData, Intake } from '../../models';
import { TranslateService } from '@ngx-translate/core';




@Component({
  selector: 'video-test',
  templateUrl: './video-test.component.html',
  styleUrls: ['./video-test.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class VideoTestComponent implements OnInit {

  @ViewChild('userVideo') hardwareVideo: any;





  @Input()
  set setIntake(setIntake: any) {
    this.intakeId = setIntake;
  }



  exam: Intake;
  intakeId: number;
  userId: number;
  videoSession: string;
  videoToken: string;
  isVideoTestOn: boolean;

  hardwareMessage: string;
  isHardwareReady: boolean;
  checkHardware: boolean;
  videoSupportHardwareMessage: string;
  videoPermisionHardwareMessage: string;
  videoTag: any;

  constructor(public hardwareChecker: HardwareCheckerService,
    private translateService: TranslateService,
    public api: Api,
    public session: Session) {
    this.intakeId = 1;
    this.isHardwareReady = true;
    this.hardwareMessage = "";
    this.checkHardware = true;
    this.isVideoTestOn = true;
    this.videoPermisionHardwareMessage = "";
    this.hardwareMessage = "";


  }

  ngOnInit() {

    try {
      this.api.getIntake(this.intakeId).subscribe(exam => {
        this.exam = exam;
        this.hardwareChecker.saveMediaInformationForIntake(this.intakeId, this.exam.userId, this.exam.videoSessionId, this.exam.videoTokenId)

        if (this.hardwareChecker.mediaSettings.hasWebcam) {
          if (this.hardwareChecker.mediaSettings.browser.name === 'Safari') {
            this.initSafari();
          } else {
            this.initOther();
          }

        } else {

          this.translateService.get('VIDEO_TEST.MSG_VIDEO_ISSUE_1').subscribe((res: string) => {
            if (res) {
              this.hardwareMessage = res;
            } else {
              this.hardwareMessage = 'Video visit issue found:  No video or microphone detected.';
            }
          });
          this.translateService.get('VIDEO_TEST.MSG_NO_VIDEO').subscribe((res: string) => {
            if (res) {
              this.videoSupportHardwareMessage = res;
            } else {
              this.videoSupportHardwareMessage = 'Video is not supported by your device.';
            }
          });
          this.translateService.get('VIDEO_TEST.VIDEO_PERM_ISSUE').subscribe((res: string) => {
            if (res) {
              this.videoPermisionHardwareMessage = res;
            } else {
              this.videoPermisionHardwareMessage = 'Video permissions and camera have been denied.';
            }
          });

          this.isHardwareReady = false;
        }






      });
    } catch (err) {
      console.log('Permission Error With Hardware ');
    }


  }

  ngOnDestroy() {
    try {
      if (this.hardwareChecker.mediaSettings.browser.name === 'Safari') {
        let win = <any>window;

        win.localStream.getVideoTracks()[0].stop();

        let video = this.hardwareVideo.nativeElement;
        video = null;
      } else {
        this.stopVideoTest();
      }
    } catch (err) {
      console.log('Permission Error With Hardware ');
    }
  }


  initSafari() {
    try {
      let _self = this;

      let video = this.hardwareVideo.nativeElement;

      let n = <any>navigator;
      let win = <any>window;

      let videoSettings = {
        audio: false,
        video: true
      };

      n.getUserMedia = (n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia);


      n.mediaDevices.getUserMedia(videoSettings).then(function (stream) {
        win.stream = stream;
        win.localStream = stream;
        video.srcObject = stream;
      }).catch(error => {
        if (error.name === 'ConstraintNotSatisfiedError') {
          _self.hardwareMessage = this.videoSupportHardwareMessage;
          _self.isHardwareReady = false;

        } else if (error.name === 'PermissionDeniedError' || error.name === 'NotAllowedError') {
          _self.hardwareMessage = this.videoPermisionHardwareMessage
          _self.isHardwareReady = false;

        } else {
          _self.hardwareMessage = this.videoSupportHardwareMessage;
          _self.isHardwareReady = false;
        }
      });
    } catch (err) {
      console.log('Permission Error With Hardware ');
    }



  }

  initOther() {
    try {
      let _self = this;

      let n = <any>navigator;

      n.getUserMedia = (n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia);



      _self.startVideoTest();

      n.permissions.query({ name: 'camera' }).then(function (permissionStatus) {
        console.log(permissionStatus);

        switch (permissionStatus.state) {
          case 'granted': {
            _self.isHardwareReady = true;
            break;
          }
          case 'prompt': {
            _self.isHardwareReady = true;
            break;
          }
          case 'denied': {
            _self.isHardwareReady = false;
            _self.hardwareMessage = this.videoPermisionHardwareMessage;
            break;
          }
          default: {

            break;
          }
        }


        permissionStatus.onchange = function () {
          try {
            switch (this.state) {
              case 'granted': {
                _self.isHardwareReady = true;
                _self.hardwareChecker.saveMediaChangesForIntake(_self.intakeId, _self.userId, _self.exam.videoSessionId, _self.exam.videoTokenId, true, true);
                _self.startVideoTest();
                break;
              }
              case 'denied': {
                _self.isHardwareReady = false;
                _self.hardwareMessage = this.videoPermisionHardwareMessage;
                _self.hardwareChecker.saveMediaChangesForIntake(_self.intakeId, _self.userId, _self.exam.videoSessionId, _self.exam.videoTokenId, false, false);
                _self.startVideoTest();
                break;
              }
              default: {
                _self.startVideoTest();
                break;
              }
            }
            console.log('Permission state has changed to ', this.state);
          } catch (err) {
            console.log('Permission Error With Hardware ');
          }







        };

      });

    } catch (err) {
      console.log('Permission Error With Hardware ');
    }



  }


  stopVideoTest() {

    try {
      let win = <any>window;

      if (win.stream) {
        win.stream.getVideoTracks()[0].stop();
      }
      if (win.localStream) {

        win.localStream.getAudioTracks()[0].stop();
        win.localStream.getVideoTracks()[0].stop();


      }

    } catch (err) {

    }

    // let video = this.hardwareVideo.nativeElement;
    // video = null;

  }

  startVideoTest() {


    try {
      let video = this.hardwareVideo.nativeElement;

      let n = <any>navigator;
      let win = <any>window;

      let videoSettings = {
        audio: true,
        video: true
      };

      n.getUserMedia = (n.getUserMedia || n.webkitGetUserMedia || n.mozGetUserMedia || n.msGetUserMedia);

      n.permissions.query({ name: 'camera' }).then(function (permissionStatus) {
        if (permissionStatus.state === 'granted') {
          n.mediaDevices.getUserMedia(videoSettings).then(function (stream) {
            video.hidden = false;
            win.stream = stream;
            win.localStream = stream;
            //video.setAttribute("playsinline", true);
            //video.setAttribute("controls", true);
            //video.src = window.URL.createObjectURL(stream);
            video.srcObject = stream;

            video.play();

          }), (err) => {
            console.log(err);
          };
        } else {

          n.mediaDevices.getUserMedia(videoSettings).then(function (stream) {
            video.pause();
            win.stream = stream;
            win.localStream = stream;
            video.srcObject = stream;
            video.hidden = true;
            //console.log('requested');
          }, error => {
            video.pause();
            video.hidden = true;
            //console.log(error);
          });

          //n.permissions.query({name:'camera', userVisibleOnly:true}).then(function (permissionStatus) {});
        }
      });



    } catch (err) {
      //console.log(err);
    }

  }


}
